<template>
  <div>
    <v-main>
      <v-container fluid>
        <v-card class="pt-3 pb-6" :class="$vuetify.breakpoint.smAndUp ? 'px-4' : 'px-2'">
          <v-row>
            <v-col cols="12">
              <p class="text-h5 mb-n2">ค้นหาผู้ใช้งานในระบบ</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <template>
                <v-card>
                  <v-tabs v-model="tab">
                    <v-tab href="#tab-1">
                      รายหน่วยงาน
                    </v-tab>
                    <v-tab href="#tab-2">
                      รายคน
                    </v-tab>
                    <v-tab href="#tab-3">
                      รายระบบ
                    </v-tab>
                  </v-tabs>

                  <v-tabs-items v-model="tab">
                    <v-tab-item value="tab-1">
                      <v-card flat>
                        <v-col cols="12">
                          <v-row class="ml-1 alight-center" justify="start">
                            <v-col cols="8">
                              <!-- <v-autocomplete
                                v-model="form2.orgLevel1"
                                :items="organReferList"
                                item-text="organizationNameTha"
                                item-value="organizationID"
                                label="หน่วยงาน"
                                outlined
                                hide-details
                                dense
                              ></v-autocomplete> -->

                              <v-row>
                                <span class="text-body-1 black--text mr-2 "
                                  >หน่วยงานที่ได้รับสิทธิ์ สำนัก/สถาบัน/คณะ :
                                </span>
                                <v-autocomplete
                                  v-model="form2.orgLevel1"
                                  :items="organReferList"
                                  item-text="organizationNameTha"
                                  item-value="organizationID"
                                  label="เลือกหน่วยงาน"
                                  placeholder="หน่วยงานชั้นที่1"
                                  outlined
                                  hide-details
                                  dense
                                  @change="getOrgLevel2Search($event)"
                                ></v-autocomplete>
                              </v-row>
                              <v-row align="center" v-if="orgDropDownLevel2ListSearch.length > 0" class="mt-2">
                                <span class="text-body-1 black--text mr-2 "
                                  >หน่วยงานที่ได้รับสิทธิ์ กอง/สำนักงาน/ภาควิชา :
                                </span>
                                <v-autocomplete
                                  v-model="form2.orgLevel2"
                                  :items="orgDropDownLevel2ListSearch"
                                  item-text="organizationNameTha"
                                  item-value="organizationID"
                                  label="เลือกหน่วยงาน"
                                  outlined
                                  hide-details
                                  dense
                                  placeholder="หน่วยงานชั้นที่2"
                                  :error="orgLevel2Status"
                                  @change="getOrgLevel3Search($event)"
                                ></v-autocomplete>
                                <p v-if="orgLevel2Status" class="error--text ml-1">
                                  *กรุณาเลือกหน่วยงานให้ครบตามระดับ
                                </p>
                              </v-row>
                              <v-row align="center " v-if="orgDropDownLevel3ListSearch.length > 0" class="mt-2">
                                <span class="text-body-1 black--text mr-2 ">หน่วยงานที่ได้รับสิทธิ์ งาน/ฝ่าย : </span>
                                <v-autocomplete
                                  v-model="form2.orgLevel3"
                                  :items="orgDropDownLevel3ListSearch"
                                  item-text="organizationNameTha"
                                  item-value="organizationID"
                                  label="เลือกหน่วยงาน"
                                  outlined
                                  hide-details
                                  dense
                                  :error="orgLevel3Status"
                                  placeholder="หน่วยงานชั้นที่3"
                                  @change="getOrgLevel4Search($event)"
                                ></v-autocomplete>
                                <p v-if="orgLevel3Status" class="error--text ml-1">
                                  *กรุณาเลือกหน่วยงานให้ครบตามระดับ
                                </p>
                              </v-row>
                              <v-row align="center " v-if="orgDropDownLevel4ListSearch.length > 0" class="mt-2">
                                <span class="text-body-1 black--text mr-2 ">หน่วยงานที่ได้รับสิทธิ์ หน่วย : </span>
                                <v-autocomplete
                                  v-model="form2.orgLevel4"
                                  :items="orgDropDownLevel4ListSearch"
                                  item-text="organizationNameTha"
                                  item-value="organizationID"
                                  label="เลือกหน่วยงาน"
                                  outlined
                                  hide-details
                                  dense
                                  :error="orgLevel4Status"
                                  placeholder="หน่วยงานชั้นที่4"
                                  @change="getOrgLevel5Search($event)"
                                ></v-autocomplete>
                                <p v-if="orgLevel4Status" class="error--text ml-1">
                                  *กรุณาเลือกหน่วยงานให้ครบตามระดับ
                                </p>
                              </v-row>
                            </v-col>
                          </v-row>
                          <v-row justify="start">
                            <v-col cols="8">
                              <v-row justify="end">
                                <v-btn elevation="2" color="primary" @click="searchBtnTab1">
                                  <v-icon> mdi-magnify </v-icon>ค้นหา</v-btn
                                >
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-data-table
                            :headers="headersTab1"
                            :items="dataTable1"
                            :items-per-page="10"
                            class="elevation-1"
                            :loading="loadtable"
                            loading-text="รอซักครู่...."
                            :footer-props="{
                              'items-per-page-text': 'จำนวนต่อหน้า',
                              pageText: '{0}-{1} ของ {2}'
                            }"
                          >
                            <template v-slot:no-data>
                              <span>ไม่มีข้อมูล</span>
                            </template>
                            <template #[`item.order`]="{ item }">
                              <p>
                                {{ dataTable1.indexOf(item) + 1 }}
                              </p>
                            </template>
                            <template #[`item.amountActive`]="{ index }">
                              <div>
                                <v-btn fab small dark @click="dialogDel = true" color="success">
                                  <span class="white--text">1</span>
                                </v-btn>
                              </div>
                            </template>
                            <template #[`item.sysCreateDateRole`]="{ index,item }">
                              <div>
                                {{ $dateFormatByLang(item.sysCreateDateRole) }}
                              </div>
                            </template>
                            <template #[`item.action`]="{ index,item  }">
                              <div>
                                <v-btn @click="dialogConDelTab1Fn(item)" color="error"
                                  ><v-icon dense dark>
                                    mdi-trash-can-outline
                                  </v-icon></v-btn
                                >
                              </div>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item value="tab-2">
                      <v-card flat>
                        <v-col cols="12">
                          <v-row class="ml-1 ">
                            <v-col cols="6">
                              <v-text-field
                                v-model="searchTab2"
                                label="ค้นหาชื่อ"
                                outlined
                                dense
                                hide-details=""
                                class="align-center"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="4">
                              <v-btn elevation="2" color="primary" @click="btnSearchTab2">
                                <v-icon> mdi-magnify </v-icon>ค้นหา</v-btn
                              >
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-data-table
                            :headers="headersTab2"
                            :items="dataTable2List"
                            :items-per-page="10"
                            class="elevation-1"
                            :loading="loadtable"
                            loading-text="รอซักครู่...."
                            :footer-props="{
                              'items-per-page-text': 'จำนวนต่อหน้า',
                              pageText: '{0}-{1} ของ {2}'
                            }"
                          >
                            <template v-slot:no-data>
                              <span>ไม่มีข้อมูล</span>
                            </template>
                            <template #[`item.order`]="{ index,item }">
                              {{ dataTable2List.indexOf(item) + 1 }}
                            </template>

                            <template #[`item.organizationName`]="{ index,item }">
                              <p class="alight-center pt-4">
                                {{ item.organizationName }}
                              </p>
                              <p class="alight-center grey--text ">
                                {{ item.accessStatus }}
                              </p>
                            </template>
                            <template #[`item.action`]="{ index,item }">
                              <div>
                                <v-btn @click="dialogConDelTab2Fn(item)" color="error"
                                  ><v-icon dense dark>
                                    mdi-trash-can-outline
                                  </v-icon></v-btn
                                >
                              </div>
                            </template>
                            <template #[`item.sysCreateDateRole`]="{ index,item }">
                              <div>
                                {{ $dateFormatByLang(item.sysCreateDateRole) }}
                              </div>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item value="tab-3">
                      <v-card flat>
                        <v-col cols="12">
                          <v-row class="ml-1 ">
                            <v-col cols="6">
                              <v-text-field
                                v-model="searchTab3"
                                label="ชื่อระบบ"
                                outlined
                                dense
                                hide-details=""
                                class="align-center"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="4">
                              <v-btn elevation="2" color="primary" @click="btnSearchTab3">
                                <v-icon> mdi-magnify </v-icon>ค้นหา</v-btn
                              >
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-data-table
                            :headers="headersTab3"
                            :items="dataTable3List"
                            :items-per-page="10"
                            class="elevation-1"
                            :loading="loadtable"
                            loading-text="รอซักครู่...."
                            :footer-props="{
                              'items-per-page-text': 'จำนวนต่อหน้า',
                              pageText: '{0}-{1} ของ {2}'
                            }"
                          >
                            <template v-slot:no-data>
                              <span>ไม่มีข้อมูล</span>
                            </template>
                            <template #[`item.order`]="{ index,item }">
                              {{ dataTable3List.indexOf(item) + 1 }}
                            </template>

                            <template #[`item.sysCreateDateRole`]="{ index,item }">
                              <div>
                                {{ $dateFormatByLang(item.sysCreateDateRole) }}
                              </div>
                            </template>
                            <template #[`item.action`]="{ index,item }">
                              <div>
                                <v-btn @click="dialogConDelTab3Fn(item)" color="error"
                                  ><v-icon dense dark>
                                    mdi-trash-can-outline
                                  </v-icon></v-btn
                                >
                              </div>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card>
              </template>
            </v-col>
          </v-row>
        </v-card>
      </v-container>
      <v-dialog v-model="dialogConDelTab1" max-width="500px">
        <v-card class="py-2">
          <v-card-title class="headline Black--text">ยืนยันการลบ</v-card-title>

          <v-card-text class="mb-3">
            <v-divider class="mb-2"></v-divider>
            <v-row>
              <v-col cols="12">
                <div>
                  <span class="text-body-1">ชื่อ: </span><span class="text-body-1">{{ setDataDel.employeeName }}</span>
                </div>
                <div>
                  <span class="text-body-1">ชื่อสิทธิ์: </span
                  ><span class="text-body-1">{{ setDataDel.accessRoleFullNameTha }}</span>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="mr-4 mt-n8">
              <v-btn class="white--text mr-2" color="error" outlined @click="dialogConDelTab1 = false">ยกเลิก </v-btn>
              <v-btn class="white--text mr-2" color="success" @click="dialogConDelTab1Con">ยืนยัน </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogConDelTab2" max-width="500px">
        <v-card class="py-2">
          <v-card-title class="headline Black--text">ยืนยันการลบ</v-card-title>

          <v-card-text class="mb-3">
            <v-divider class="mb-2"></v-divider>
            <v-row>
              <v-col cols="12">
                <div>
                  <span class="text-body-1">ชื่อ: </span><span class="text-body-1">{{ setDataDel2.employeeName }}</span>
                </div>
                <div>
                  <span class="text-body-1">ชื่อสิทธิ์: </span
                  ><span class="text-body-1">{{ setDataDel2.accessRoleFullNameTha }}</span>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="mr-4 mt-n8">
              <v-btn class="white--text mr-2" color="error" outlined @click="dialogConDelTab2 = false">ยกเลิก </v-btn>
              <v-btn class="white--text mr-2" color="success" @click="dialogConDelTab2Con">ยืนยัน </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogConDelTab3" max-width="500px">
        <v-card class="py-2">
          <v-card-title class="headline Black--text">ยืนยันการลบ</v-card-title>

          <v-card-text class="mb-2">
            <v-divider class="mb-2"></v-divider>
            <v-row>
              <v-col cols="12">
                <div>
                  <span class="text-body-1">ชื่อ: </span><span class="text-body-1">{{ setDataDel3.employeeName }}</span>
                </div>
                <div>
                  <span class="text-body-1">ชื่อสิทธิ์: </span
                  ><span class="text-body-1">{{ setDataDel3.accessRoleFullNameTha }}</span>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="mr-4 mt-n8">
              <v-btn class="white--text mr-2" color="error" outlined @click="dialogConDelTab3 = false">ยกเลิก </v-btn>
              <v-btn class="white--text mr-2" color="success" @click="dialogConDelTab3Con">ยืนยัน </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-main>
    <v-dialog v-model="loading1" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      headersTab1: [
        {
          text: 'ลำดับ',
          value: 'order',
          class: 'black--text grey lighten-4 text-body-1',
          align: 'center'
        },
        {
          text: 'ชื่อ-สกุล',
          value: 'employeeName',
          sortable: false,
          class: 'black--text grey lighten-4 text-body-1',
          align: 'start'
        },

        {
          text: 'ชื่อสิทธิ์',
          value: 'accessRoleFullNameTha',
          sortable: false,
          class: 'black--text grey lighten-4 text-body-1',
          align: 'start'
        },

        {
          text: 'กำหนดสิทธิ์เมื่อ',
          value: 'sysCreateDateRole',
          sortable: false,
          class: 'black--text grey lighten-4 text-body-1',
          align: 'center'
        },
        {
          text: 'จัดการ',
          value: 'action',
          sortable: false,
          class: 'black--text grey lighten-4 text-body-1',
          align: 'center'
        }
      ],
      headersTab2: [
        {
          text: 'ลำดับ',
          value: 'order',
          class: 'black--text grey lighten-4 text-body-1',
          align: 'center'
        },
        {
          text: 'ชื่อ',
          value: 'employeeName',
          sortable: false,
          class: 'black--text grey lighten-4 text-body-1',
          align: 'start',
          width: '18%'
        },
        {
          text: 'ชื่อสิทธิื',
          value: 'accessRoleFullNameTha',
          sortable: false,
          class: 'black--text grey lighten-4 text-body-1',
          align: 'start'
        },

        {
          text: 'หน่วยงานที่ได้รับสิทธิ์',
          value: 'organizationName',
          sortable: false,
          class: 'black--text grey lighten-4 text-body-1',
          align: 'start'
        },

        // {
        //   text: 'สิทธิ์ในหน่วยงาน',
        //   value: 'accessStatus',
        //   sortable: false,
        //   class: 'black--text grey lighten-4',
        //   align: 'center'
        // },
        {
          text: 'การมองเห็น',
          value: 'organizationOnlyStatusName',
          sortable: false,
          class: 'black--text grey lighten-4 text-body-1',
          align: 'start'
        },
        {
          text: 'กำหนดสิทธิ์เมื่อ',
          value: 'sysCreateDateRole',
          sortable: false,
          class: 'black--text grey lighten-4 text-body-1',
          align: 'center'
        },
        {
          text: 'จัดการ',
          value: 'action',
          sortable: false,
          class: 'black--text grey lighten-4',
          align: 'center'
        }
      ],
      headersTab3: [
        {
          text: 'ลำดับ',
          value: 'order',
          class: 'black--text grey lighten-4 text-body-1',
          align: 'center'
        },
        {
          text: 'ชื่อ-สกุล',
          value: 'employeeName',
          sortable: false,
          class: 'black--text grey lighten-4 text-body-1',
          align: 'start'
        },

        {
          text: 'ชื่อสิทธิ์',
          value: 'accessRoleFullNameTha',
          sortable: false,
          class: 'black--text grey lighten-4 text-body-1',
          align: 'start'
        },
        {
          text: 'หน่วยงานที่ได้รับสิทธิ์',
          value: 'organizationName',
          sortable: false,
          class: 'black--text grey lighten-4 text-body-1',
          align: 'start'
        },
        {
          text: 'กำหนดสิทธิ์เมื่อ',
          value: 'sysCreateDateRole',
          sortable: false,
          class: 'black--text grey lighten-4 text-body-1',
          align: 'center'
        },
        {
          text: 'จัดการ',
          value: 'action',
          sortable: false,
          class: 'black--text grey lighten-4 text-body-1',
          align: 'center'
        }
      ],
      info: [],
      form2: {
        orgLevel1: '',
        orgLevel2: '',
        orgLevel3: '',
        orgLevel4: ''
      },
      orgDropDownLevel1List: [],
      orgDropDownLevel2List: [],
      orgDropDownLevel3List: [],
      orgDropDownLevel4List: [],
      orgDropDownLevel1ListSearch: [],
      orgDropDownLevel2ListSearch: [],
      orgDropDownLevel3ListSearch: [],
      orgDropDownLevel4ListSearch: [],
      orgLevel2Status: false,
      orgLevel3Status: false,
      orgLevel4Status: false,
      loading: false,

      dialogConDelTab1: false,
      dialogConDelTab2: false,
      dialogConDelTab3: false,
      // ReqEventList: []
      organReferList: [],
      tab: null,
      dataTable1: [],
      loadtable: false,
      setDataDel: {},
      loading1: false,
      searchTab2: '',
      dataTable2List: [],
      setDataDel2: {},
      searchTab3: '',
      dataTable3List: [],
      setDataDel3: {},
      payloadSelect: {}

      //   tabitems: [
      //     { tab: 'รายงานหน่วย', content: 'Tab 1 Content' },
      //     { tab: 'รายคน', content: 'Tab 2 Content' },
      //     { tab: 'รายระบบ', content: 'Tab 3 Content' }
      //   ]
    };
  },

  // computed: {
  //   ReqEventList() {
  //     return [
  //       {
  //         row: 'Frozen Yogurt',
  //         order: 159,
  //         title: 6.0,
  //         activeStatus: 24,
  //         action: 4.0
  //       }
  //     ]
  //   }
  // },
  async mounted() {
    await this.initialInfo();
  },
  methods: {
    async initialInfo() {
      const payLoad = {
        organId: '20B4C3A9-76A2-4413-9607-05FFEB06C724',
        orgTypeFlag: 2
      };
      this.organReferList = await this.OrganReferApi(payLoad);

      this.form2.orgLevel1 = this.organReferList[0].organizationID;

      const payload2 = {
        organId: this.form2.orgLevel1
      };
      //console.log('dasdasd' + JSON.stringify(payload2))
      this.dataTable1 = await this.getDataTable1Api(payload2);

      await this.getOrgLevel2Search();
    },
    async getOrgLevel2Search() {
      const payLoad = {
        organId: this.form2.orgLevel1,
        orgTypeFlag: 2
      };
      //console.log('dasd222 ' + JSON.stringify(payLoad))
      const res = await this.OrganReferApi(payLoad);
      this.resSearchList = [];
      this.orgDropDownLevel2ListSearch = res;
      this.orgDropDownLevel3ListSearch = [];
      this.orgDropDownLevel4ListSearch = [];
      this.form2.orgLevel2 = '';
      this.form2.orgLevel3 = '';
      this.form2.orgLevel4 = '';
      this.orgLevel2Status = false;
      this.orgLevel3Status = false;
      this.orgLevel4Status = false;
    },
    async getOrgLevel3Search() {
      const payLoad = {
        organId: this.form2.orgLevel2,
        orgTypeFlag: 2
      };
      //console.log('dasd333 ' + JSON.stringify(payLoad))
      const res = await this.OrganReferApi(payLoad);
      this.resSearchList = [];
      this.orgDropDownLevel3ListSearch = res;
      this.orgDropDownLevel4ListSearch = [];
      this.form2.orgLevel3 = '';
      this.form2.orgLevel4 = '';
      this.orgLevel2Status = false;
      this.orgLevel3Status = false;
      this.orgLevel4Status = false;
    },
    async getOrgLevel4Search() {
      const payLoad = {
        organId: this.form2.orgLevel3,
        orgTypeFlag: 2
      };
      //console.log('dasd444 ' + JSON.stringify(payLoad))
      const res = await this.OrganReferApi(payLoad);
      this.resSearchList = [];
      this.orgDropDownLevel4ListSearch = res;
      this.form2.orgLevel4 = '';
      this.orgLevel2Status = false;
      this.orgLevel3Status = false;
      this.orgLevel4Status = false;
    },
    async getOrgLevel5Search() {
      this.resSearchList = [];
      this.orgLevel2Status = false;
      this.orgLevel3Status = false;
      this.orgLevel4Status = false;
    },
    async OrganReferApi(payLoad) {
      try {
        // this.loadtable3 = true

        const res = await this.$store.dispatch('adminmanage/organList', payLoad);
        if (res.data.data.length !== 0) {
          // this.loadtable3 = false
          return res.data.data;
        } else {
          res.data = [];
          // this.loadtable3 = false
          return res.data;
        }
      } catch (e) {
        console.log(e.response || e);
      }
    },
    async searchBtnTab1() {
      if (this.form2.orgLevel4 !== '') {
        this.payloadSelect = {
          organId: this.form2.orgLevel4
        };
      } else if (this.form2.orgLevel3 !== '') {
        this.payloadSelect = {
          organId: this.form2.orgLevel3
        };
      } else if (this.form2.orgLevel2 !== '') {
        this.payloadSelect = {
          organId: this.form2.orgLevel2
        };
      } else {
        this.payloadSelect = {
          organId: this.form2.orgLevel1
        };
      }
      // console.log('sdasdas ' + JSON.stringify(this.payloadSelect))
      this.dataTable1 = await this.getDataTable1Api(this.payloadSelect);
      // console.log('sdasdas ' + JSON.stringify(resdatas))
    },
    async getDataTable1Api(payLoad) {
      try {
        this.loadtable = true;
        const res = await this.$store.dispatch('adminmanage/dataTab1Api', payLoad);
        if (res.data.data.length !== 0) {
          this.loadtable = false;
          return res.data.data;
        } else {
          res.data = [];
          this.loadtable = false;
          return res.data;
        }
      } catch (e) {
        console.log(e.response || e);
      }
    },
    dialogConDelTab1Fn(item) {
      //console.log(item)
      this.setDataDel = {
        employeeName: item.employeeName,
        accessRoleFullNameTha: item.accessRoleFullNameTha,
        accessRoleID: item.accessRoleID,
        employeeID: item.employeeID
      };
      this.dialogConDelTab1 = true;
    },
    async dialogConDelTab1Con() {
      this.dialogConDelTab1 = false;
      this.loading1 = true;
      const res = await this.delTab1ConApi(this.setDataDel);
      if (res) {
        this.loading1 = false;
        await this.searchBtnTab1();
      }
    },
    async delTab1ConApi(payLoad) {
      try {
        const res = await this.$store.dispatch('adminmanage/delTab1ConApi', payLoad);
        return res.data;
      } catch (e) {
        console.log(e.response || e);
      }
    },
    async btnSearchTab2() {
      const payload = {
        Keyword: this.searchTab2
      };
      this.dataTable2List = await this.btnSearchTab2Api(payload);
      // console.log('sdasdas ' + JSON.stringify(resdatas))
    },
    async btnSearchTab2Api(payLoad) {
      try {
        this.loadtable = true;

        const res = await this.$store.dispatch('adminmanage/btnSearchTab2Api', payLoad);
        // console.log('test ' + JSON.stringify(res))
        if (res.data.length !== 0) {
          this.loadtable = false;
          return res.data.data;
        } else {
          res.data = [];
          this.loadtable = false;
          return res.data;
        }
      } catch (e) {
        console.log(e.response || e);
      }
    },
    dialogConDelTab2Fn(item) {
      // console.log(item)
      this.setDataDel2 = {
        accessRoleFullNameTha: item.accessRoleFullNameTha,
        accessRoleID: item.accessRoleID,
        employeeName: item.employeeName,
        employeeID: item.employeeID
      };
      this.dialogConDelTab2 = true;
    },
    async dialogConDelTab2Con() {
      this.dialogConDelTab2 = false;
      this.loading1 = true;
      const res = await this.delTab1ConApi(this.setDataDel2);
      if (res) {
        this.loading1 = false;
        await this.btnSearchTab2();
      }
    },
    async btnSearchTab3() {
      const payload = {
        ProgramCatelogName: this.searchTab3
      };
      this.dataTable3List = await this.btnSearchTab3Api(payload);
      // console.log('sdasdas ' + JSON.stringify(resdatas))
    },
    async btnSearchTab3Api(payLoad) {
      try {
        this.loadtable = true;

        const res = await this.$store.dispatch('adminmanage/btnSearchTab3Api', payLoad);
        // console.log('test ' + JSON.stringify(res))
        if (res.data.length !== 0) {
          this.loadtable = false;
          return res.data.data;
        } else {
          res.data = [];
          this.loadtable = false;
          return res.data;
        }
      } catch (e) {
        console.log(e.response || e);
      }
    },
    dialogConDelTab3Fn(item) {
      // console.log(item)
      this.setDataDel3 = {
        accessRoleFullNameTha: item.accessRoleFullNameTha,
        accessRoleID: item.accessRoleID,
        employeeName: item.employeeName,
        employeeID: item.employeeID
      };
      this.dialogConDelTab3 = true;
    },
    async dialogConDelTab3Con() {
      this.dialogConDelTab3 = false;
      this.loading1 = true;
      const res = await this.delTab1ConApi(this.setDataDel3);
      if (res) {
        this.loading1 = false;
        await this.btnSearchTab3();
      }
    }
  }
};
</script>
